<template>
    <div class="filled-content">
        <v-toolbar app flat dark color="primary">
            <v-btn icon @click="gotoOverview()">
                <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title>Apparaat gegevens</v-toolbar-title>
            <v-btn icon></v-btn>
        </v-toolbar>

        <v-content class="uf-form" v-if="device">
            <v-container class="item-group" mb-4>
                <div class="headline">
                    {{ device.name }}
                </div>
                <div>
                    ID: {{ device.id_for_humans }}
                </div>
                <div>
                    EID: {{ device.eid }}
                </div>
                <div>
                    Firmware: {{ device.getFirmware() }}
                </div>
            </v-container>

            <v-container class="item-group" mb-4>
                <v-text-field
                        v-model="device.name"
                        label="Naam"
                        placeholder=" "
                        counter="16"
                        required
                ></v-text-field>
            </v-container>

            <v-container class="item-group" mb-4>
                <v-select
                        v-model="device.icon_slug"
                        :items="icons"
                        item-text="name"
                        item-value="slug"
                        label="Icoon"
                        placeholder="Standaard"
                        required
                >
                </v-select>
            </v-container>

<!--            <v-container class="item-group" mb-4>-->
<!--                <v-layout>-->
<!--                    <v-text-field-->
<!--                            label="Afbeelding"-->
<!--                            placeholder=" "-->
<!--                            disabled-->
<!--                            required-->
<!--                    ></v-text-field>-->
<!--                    <v-upload-btn></v-upload-btn>-->
<!--                </v-layout>-->
<!--            </v-container>-->

            <v-container class="item-group" mb-4>
                <image-gallery :device-id="device.id"
                               :device-images="device.images"
                               :maximum-images="6"
                ></image-gallery>
            </v-container>

            <v-container class="item-group">
                <v-textarea
                        v-model="device.notes"
                        label="Omschrijving"
                        placeholder=" "
                        counter="255"
                        required
                        auto-grow
                ></v-textarea>
            </v-container>
            <v-container v-if="false">
                <v-btn block dark depressed flat large color="red">E-finder verwijderen</v-btn>
            </v-container>
        </v-content>
    </div>
</template>

<script>
export default {
  data() {
    return {
      icons: [
        { name: 'Aanhanger', slug: 'e800' },
        { name: 'Auto', slug: 'e801' },
        { name: 'Bagage', slug: 'e802' },
        { name: 'Boot', slug: 'e803' },
        { name: 'Camper', slug: 'e804' },
        { name: 'Caravan', slug: 'e805' },
        { name: 'Fiets', slug: 'e806' },
        { name: 'Huisdier', slug: 'e807' },
        { name: 'Motor', slug: 'e808' },
        { name: 'Scootmobiel', slug: 'e80A' },
        { name: 'Scooter', slug: 'e80B' },
        { name: 'Overig', slug: 'e80D' },
        { name: 'A', slug: 'A' },
        { name: 'B', slug: 'B' },
        { name: 'C', slug: 'C' },
        { name: 'D', slug: 'D' },
        { name: 'E', slug: 'E' },
        { name: 'F', slug: 'F' },
        { name: 'G', slug: 'G' },
        { name: 'H', slug: 'H' },
        { name: 'I', slug: 'I' },
        { name: 'J', slug: 'J' },
      ],
    };
  },
  computed: {
    device() {
      return this.$store.getters.device;
    },
  },
  methods: {
    gotoOverview() {
      if (!this.device.name) return; // TODO: Show error

      this.$store.dispatch('updateDevice', {
        id: this.device.id,
        data: {
          name: this.device.name,
          icon_slug: this.device.icon_slug,
          notes: this.device.notes,
        },
      }).then(() => {
          this.$router.go(-1);
      });
    },
  },
  created() {
    this.$store.dispatch('selectDevice', this.$route.params.id);
  },
};
</script>

<style lang="stylus">
    .uf-form
        background-color: #f2f2f2

        .item-group
            background-color: #fff
            border-top: solid 1px #ddd
            border-bottom: solid 1px #ddd
</style>
